// extracted by mini-css-extract-plugin
module.exports = {"prospectusBacImg":"footer_prospectusBacImg__1cJEj"};